export async function jsonFieldParser(value: string) {
  try {
    const fixedValue = value.replace(/([a-zA-Z0-9_]+)(?=\s*:)/g, '"$1"');
    return await JSON.parse(fixedValue);
  } catch (e) {
    console.error(e);
    throw e;
  }
}
